export function TickDot({ size = 64, className = '' }: { size?: number; className?: string }) {
  const scale = size / 200;
  const circleRadius = 98 * scale;
  const cx = size / 2;
  const cy = size / 2;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className={className} aria-hidden="true">
      <circle cx={cx} cy={cy} r={circleRadius} fill="#1D9E75" />
      <g transform={`translate(${cx}, ${cy + size * 0.05}) scale(${scale}) translate(-100, -110)`}>
        <path d="M 37 107 Q 43 104 50 101 L 90 151 Q 87 157 80 161 Q 60 141 37 107 Z" fill="#ffffff" />
        <path d="M 80 161 Q 87 157 90 151 Q 107 107 147 47 Q 157 45 162 51 Q 160 58 143 81 Q 117 124 93 164 Q 83 166 80 161 Z" fill="#ffffff" />
      </g>
    </svg>
  );
}
